import cookies from 'js-cookie';

export const setCookie = (key, value) => {
    cookies.set(key, value);
};

export const getCookie = (key) => {
    return cookies.get(key);
};

export const removeCookie = (key) => {
    cookies.remove(key);
};
